import { ErrorController, RestError } from "$lib/controller/error"
import { isProduction } from "$lib/environment"
import * as Sentry from "@sentry/sveltekit"
import { initCobrowse } from "@tastyworks/shared-cobrowse/cobrowse"
import { applyHoneycombSessionToSentryEvent } from "@tastyworks/shared-web-telemetry/sentry-correlation"
import { recordTelemetryException } from "@tastyworks/shared-web-telemetry/telemetry"

initCobrowse({ license: import.meta.env.VITE_COBROWSE_LICENSE_KEY }).catch(
  recordTelemetryException
)

// Browser OpenTelemetry tracing is initialised from the root +layout
// (see $lib/telemetry) once the LaunchDarkly `ao2-otel` flag can be read.

if (isProduction()) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: __APP_VERSION__,
    ignoreErrors: [
      // GTM noise, not impactful to user experience
      "Failed to fetch TypeError /gtag/js Mc Mc(gtag/js)",
      // Sentry's own framework wrapper error, expected per Sentry source:
      // "If you are a Sentry user, and you are seeing this stack frame, it
      // means the sentry.javascript SDK caught an error invoking your
      // application code. This is expected behavior and NOT indicative of a
      // bug with sentry.javascript."
      "Cookies is not defined",
      "Can't find variable: Cookies",
    ],
    integrations: [
      Sentry.extraErrorDataIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ["assert"],
      }),
    ],
    beforeSend(event, hint) {
      const { originalException } = hint
      if (originalException instanceof RestError) {
        event.message = ErrorController.getRestErrorMessage(originalException)
      }

      // SvelteKit routes failures to handleError, so they never reach the SDK's
      // window-level error instrumentation.
      recordTelemetryException(originalException)
      return applyHoneycombSessionToSentryEvent(event)
    },
  })
}

export const handleError = isProduction()
  ? Sentry.handleErrorWithSentry(ErrorController.handleLoadError)
  : ErrorController.handleLoadError
